import React from 'react';
import { ThemeProvider } from '@material-ui/core/styles';
import CssBaseline from '@material-ui/core/CssBaseline';
import Paper from '@material-ui/core/Paper';
import BasicInformation from './BasicInformation';
import NavBar from './NavBar'
import Progress from "./ProgressBar"
import Theme from '../theme/CustomTheme'
import useStyles from '../styles/CustomStyle'
import '../styles/ResponsiveStyle.css'
import axios from "axios"
import AdditionalInformationWrapper from './AdditionalInformationWrapper';
import Copyright from './Copyright'
import moment from 'moment'

function getStepContent(step, stepContent, handleChange, handleNext, handleBack, handleSubmit, areas, setAreas, brands, setBrands, models, setModels, alert, setAlert, bankType, setBankType) {
  switch (step) {
    case 0:
      return <BasicInformation stepContent={stepContent} handleChange={handleChange} handleNext={handleNext} handleBack={handleBack} areas={areas} setAreas={setAreas} />;
    case 1:
      return <AdditionalInformationWrapper stepContent={stepContent} handleChange={handleChange} handleNext={handleNext} handleBack={handleBack} brands={brands} setBrands={setBrands} models={models} setModels={setModels} handleSubmit={handleSubmit} bankType={bankType} setBankType={setBankType} />;
    case 2:
      return <Progress handleSubmit={handleSubmit} alert={alert} handleBack={handleBack} setAlert={setAlert} />;
    case 3:
      return <Progress handleSubmit={handleSubmit} />
    default:
      throw new Error('Unknown step');
  }
}

export default function RideRegistration(props) {
  const classes = useStyles();
  let imageObj = {
    file: "",
    fileUrl: "",
    fileData: {}
  }
  const [activeStep, setActiveStep] = React.useState(0);
  const [areas, setAreas] = React.useState([])
  const [brands, setBrands] = React.useState([])
  const [models, setModels] = React.useState([])
  const [bankType, setBankType] = React.useState("")
  const [alert, setAlert] = React.useState({
    show: false,
    type: "",
    title: "",
    text: "",
  })
  const [stepContent, setStepContent] = React.useState({
    nameCtrl: "",
    phoneCtrl: "",
    genderCtrl: "",
    emailCtrl: "",
    salesPerson: "",
    city: "",
    area: "",
    referenceCtrl: "",
    car_type: "",
    vehicle_identification_no: "",
    vehicle_registration_year: "",
    max_passengers: "",
    vehicle_year: "",
    vehicle_make: "",
    vehicle_model: "",
    owner: true,
    registeredOwnerName: "",
    registeredOwnerphone: "",
    registeredOwneremail: "",
    owner_photo: imageObj,
    owner_nid_passport_front: imageObj,
    owner_nid_passport_back: imageObj,
    driver_photo: imageObj,
    driver_nid_passport_front: imageObj,
    nid_no: "",
    date_of_birth: null,
    driver_nid_passport_back: imageObj,
    driving_license_front: imageObj,
    driver_license_no: "",
    license_plate_district: "",
    license_plate_series: "",
    license_plate_no: "",
    license_expiry_date: null,
    driver_license_exp: null,
    driving_license_back: imageObj,
    driving_registration_front: imageObj,
    driving_registration_back: imageObj,
    tax_token: imageObj,
    insurance: imageObj,
    fitness: imageObj,
    account_holder_name: "",
    bank_account_number: "",
    bank_name: "",
    branch_name: "",
    bkash_id: "",
    rocket_id: "",
    nagad_id: "",
    alert_type: ""
  });
  const handleChange = (event, flag) => {
    if (flag === "registeredOwnerphone" || flag === "phoneCtrl" || flag === "owner" || flag === "bkash_id" || flag === "rocket_id" || flag === "nagad_id" || flag === "license_expiry_date" || flag === "date_of_birth" || flag === "driver_license_exp" || flag === "license_plate_no") {
      setStepContent({
        ...stepContent,
        [flag]: event
      });
    } else if (flag === "owner_photo" || flag === "owner_nid_passport_front" || flag === "owner_nid_passport_back" || flag === "driver_photo" || flag === "driver_nid_passport_front" || flag === "driver_nid_passport_back" || flag === "driving_license_front" || flag === "driving_license_back" || flag === "driving_registration_front" || flag === "driving_registration_back" || flag === "tax_token" || flag === "insurance" || flag === "fitness") {
      setStepContent({
        ...stepContent,
        [flag]: {
          file: event[event.length - 1],
          // fileData: formData
        }
      });

    } else if (event.target.name === "city") {
      setStepContent({
        ...stepContent,
        city: event.target.value,
        area: ""
      });
    } else if (event.target.name === "car_type") {
      if (event.target.value === 0 || event.target.value === 10 || event.target.value === 11 || event.target.value === 12 || event.target.value === 13 || event.target.value === 14 || event.target.value === 15) {
        setStepContent({
          ...stepContent,
          car_type: event.target.value,
          vehicle_make: "",
          vehicle_model: "",
          max_passengers: 4
        });
      } else if (event.target.value === 3 || event.target.value === 4) {
        setStepContent({
          ...stepContent,
          car_type: event.target.value,
          vehicle_make: "",
          vehicle_model: "",
          max_passengers: 1
        });
      } else if (event.target.value === 5 || event.target.value === 9) {
        setStepContent({
          ...stepContent,
          car_type: event.target.value,
          vehicle_make: "",
          vehicle_model: "",
          max_passengers: 3
        });
      }

    } else if (event.target.name === "vehicle_make") {
      setStepContent({
        ...stepContent,
        vehicle_make: event.target.value,
        vehicle_model: ""
      });
    }
    else {
      setStepContent({
        ...stepContent,
        [event.target.name]: event.target.value
      });
    }
  };

  const handleSubmit = () => {
    let license_plate;
    if (stepContent.license_plate_district === "Dhaka" || stepContent.license_plate_district === "Chittagong") {
      license_plate = stepContent.license_plate_district + " Metro-" + stepContent.license_plate_series + " " + stepContent.license_plate_no
    } else {
      license_plate = stepContent.license_plate_district + " " + stepContent.license_plate_series + " " + stepContent.license_plate_no
    }
    const formData = new FormData();
    formData.append("nameCtrl", stepContent.nameCtrl)
    formData.append("phoneCtrl", stepContent.phoneCtrl)
    formData.append("genderCtrl", stepContent.genderCtrl)
    if (stepContent.emailCtrl) {
      formData.append("emailCtrl", stepContent.emailCtrl)
    }
    formData.append("city", stepContent.city)
    formData.append("area", stepContent.area)
    if (stepContent.referenceCtrl === "Sales Force") {
      formData.append("sales_person", stepContent.salesPerson)
    } else {
      formData.append("sales_person", stepContent.referenceCtrl)
    }
    formData.append("car_type", stepContent.car_type)
    formData.append("vehicle_identification_no", stepContent.vehicle_identification_no)
    formData.append("vehicle_registration_year", stepContent.vehicle_registration_year)
    formData.append("vehicle_year", stepContent.vehicle_year)
    formData.append("vehicle_make", stepContent.vehicle_make)
    formData.append("vehicle_model", stepContent.vehicle_model)
    formData.append("max_passengers", stepContent.max_passengers)
    formData.append("owner", stepContent.owner)
    formData.append("registeredOwnerName", stepContent.registeredOwnerName)
    formData.append("registeredOwnerphone", stepContent.registeredOwnerphone)
    formData.append("registeredOwneremail", stepContent.registeredOwneremail)
    formData.append("owner_photo", stepContent.owner_photo.file)
    formData.append("owner_nid_passport_front", stepContent.owner_nid_passport_front.file)
    formData.append("owner_nid_passport_back", stepContent.owner_nid_passport_back.file)
    formData.append("driver_photo", stepContent.driver_photo.file)
    formData.append("driver_nid_passport_front", stepContent.driver_nid_passport_front.file)
    formData.append("nid_no", stepContent.nid_no)
    formData.append("date_of_birth", moment(stepContent.date_of_birth).format('YYYY/MM/DD'))
    formData.append("driver_nid_passport_back", stepContent.driver_nid_passport_back.file)
    formData.append("driving_license_front", stepContent.driving_license_front.file)
    formData.append("driver_license_no", stepContent.driver_license_no)
    formData.append("licenese_expiry_date", moment(stepContent.license_expiry_date).format('YYYY/MM/DD'))
    formData.append("driver_license_exp", moment(stepContent.driver_license_exp).format('YYYY/MM/DD'))
    formData.append("driving_license_back", stepContent.driving_license_back.file)
    formData.append("driving_registration_front", stepContent.driving_registration_front.file)
    formData.append("driving_registration_back", stepContent.driving_registration_back.file)
    formData.append("tax_token", stepContent.tax_token.file)
    formData.append("insurance", stepContent.insurance.file)
    formData.append("fitness", stepContent.fitness.file)
    formData.append("account_holder_name", stepContent.account_holder_name)
    formData.append("bank_account_number", stepContent.bank_account_number)
    formData.append("bank_name", stepContent.bank_name)
    formData.append("branch_name", stepContent.branch_name)
    formData.append("bkash_id", stepContent.bkash_id)
    formData.append("rocket_id", stepContent.rocket_id)
    formData.append("nagad_id", stepContent.nagad_id)
    formData.append("driver_owner_flag", 1)
    formData.append("image_upload_flag", 1)
    formData.append("vehicle_license_plate", license_plate)

    //for test purpose
  //   for (var pair of formData.entries()) {
  //     console.log(pair[0]+ ', ' + pair[1]); 
  // }

    axios({
      method: 'post',
      url: process.env.REACT_APP_REG_API_BASE + '/add_driver_from_reg_portal',
      headers: {
        'Content-Type': 'multipart/form-data',
        'Authorization': JSON.parse(localStorage.getItem('token'))
      },
      data: formData
    }).then(res => {
      if (res.data.body.status === 201) {
        setAlert({
          show: true,
          type: "error",
          title: res.data.body.message
        })

      } else if (res.data.body.status === 200) {
        setAlert({
          show: true,
          type: "success",
          title: res.data.body.message,
          text: "Pending for approval"
        })
      }
    }).catch(err => {
      setAlert({
        show: true,
        type: "error",
        title: "Something went wrong!",
        text: "Please check your internet connection"
      })
    })

  }
  const handleNext = () => {
    setActiveStep(activeStep + 1);
  };

  const handleBack = () => {
    setActiveStep(activeStep - 1);
  };
  return (
    <React.Fragment>
      <CssBaseline />
      <NavBar showMenu={true} title="Driver Registration" />
      <main className={`${classes.layout} layout`} >
        <Paper className={classes.paper} style={{ marginTop: 90 }} elevation={4}>
          <ThemeProvider theme={Theme}>
            {getStepContent(activeStep, stepContent, handleChange, handleNext, handleBack, handleSubmit, areas, setAreas, brands, setBrands, models, setModels, alert, setAlert, bankType, setBankType)}
          </ThemeProvider>
        </Paper>
        <Copyright />
      </main>
    </React.Fragment>
  );
}